import React from "react";
import "./Pages.css";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Terms and Conditions</h1>
      <p>
        By using Destination Dreams Travel website and services, you agree to our terms and conditions. Bookings are subject to airline and hotel policies. Ensure all personal information is accurate before submitting forms.
      </p>
      <h2>Booking Policies</h2>
      <ul>
        <li>All bookings are confirmed subject to availability.</li>
        <li>Changes or cancellations may incur charges.</li>
        <li>Travelers must comply with local laws and travel requirements.</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
